import { uuid } from '@tvg/fuse-utils';
import PropTypes from 'prop-types';
import React from 'react';
import {
	StyledCheckbox,
	StyledInput,
	StyledLabel,
	StyledLabelTappableArea,
} from './styled-baseinput';

const { memo, useState, useCallback, useMemo, useEffect } = React;

const propTypes = {
	children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
	name: PropTypes.string.isRequired,
	analyticsId: PropTypes.string,
	className: PropTypes.string,
	errorMessageId: PropTypes.string,
	isChecked: PropTypes.bool,
	isDisabled: PropTypes.bool,
	isError: PropTypes.bool,
	onChange: PropTypes.func,
	value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	componentId: PropTypes.string,
};

const defaultProps = {
	analyticsId: '',
	className: '',
	errorMessageId: undefined,
	isChecked: false,
	isDisabled: false,
	isError: false,
	onChange: null,
	value: '',
	componentId: uuid(),
};

function BaseInput({
	children,
	name,
	analyticsId,
	className,
	errorMessageId,
	isChecked,
	isDisabled,
	isError,
	onChange,
	value,
	componentId,
	...others
}) {
	const [checked, setChecked] = useState(!!isChecked);
	const id = useMemo(() => `${name}_${componentId}`, [name, componentId]);

	const handleChange = useCallback(
		(event) => {
			setChecked(event?.target?.checked);
			if (typeof onChange === 'function') onChange(event);
		},
		[onChange],
	);

	useEffect(() => {
		setChecked(isChecked);
	}, [isChecked]);

	return (
		<StyledCheckbox>
			<StyledInput
				name={name}
				aria-describedby={errorMessageId || undefined}
				data-analyticsid={analyticsId}
				checked={checked}
				className={className}
				disabled={!!isDisabled}
				id={id}
				onChange={handleChange}
				type="checkbox"
				value={value}
				{...others}
			/>
			<StyledLabel aria-invalid={isError || undefined} htmlFor={id}>
				<StyledLabelTappableArea>{children}</StyledLabelTappableArea>
			</StyledLabel>
		</StyledCheckbox>
	);
}

BaseInput.propTypes = propTypes;
BaseInput.defaultProps = defaultProps;

export default memo(BaseInput);
